module.exports = __webpack_public_path__ + "img/139.7a211059.png";